"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableMask = void 0;
var tslib_1 = require("tslib");
var fast_xml_parser_1 = require("fast-xml-parser");
var mobx_1 = require("mobx");
var drawable_1 = require("./drawable");
var parser = new fast_xml_parser_1.XMLParser({
    attributeNamePrefix: '',
    ignoreAttributes: false,
    parseAttributeValue: true,
    trimValues: true,
    // all groups should be parsed as arrays even if there is only one child
    isArray: function (name) {
        if (name === 'g') {
            return true;
        }
        return false;
    }
});
var CollectionModelDrawableMask = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelDrawableMask, _super);
    function CollectionModelDrawableMask(collectionModelDrawableState, drawableId, pukekoLocation) {
        var _this = _super.call(this, collectionModelDrawableState, drawableId) || this;
        /**
         * @deprecated Write an async method to get this if it hasn't already been fetched, then return the value
         */
        _this.parsedSvg = null;
        _this.svgStringInFlight = false;
        _this.pukekoLocation = tslib_1.__assign({}, pukekoLocation);
        return _this;
    }
    Object.defineProperty(CollectionModelDrawableMask.prototype, "isInsightMeasurement", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableMask.prototype.isApprovableInsightDrawable = function () {
        return false;
    };
    Object.defineProperty(CollectionModelDrawableMask.prototype, "isVisible", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableMask.prototype, "x", {
        get: function () {
            var _a, _b;
            return ((_b = (_a = this.drawableState.capture) === null || _a === void 0 ? void 0 : _a.resolution.width) !== null && _b !== void 0 ? _b : 0) / 2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableMask.prototype, "y", {
        get: function () {
            var _a, _b;
            return ((_b = (_a = this.drawableState.capture) === null || _a === void 0 ? void 0 : _a.resolution.height) !== null && _b !== void 0 ? _b : 0) / 2;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableMask.prototype.fetchSvgMask = function (fetchingCallBack) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var svgString;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // If the string already exists or is in flight, don't fetch it again
                        if (this.parsedSvg) {
                            return [2 /*return*/];
                        }
                        if (this.svgStringInFlight) {
                            return [2 /*return*/];
                        }
                        this.svgStringInFlight = true;
                        return [4 /*yield*/, fetchingCallBack()];
                    case 1:
                        svgString = _a.sent();
                        this.parsedSvg = parser.parse(svgString);
                        this.svgStringInFlight = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Check if the mask SVG has been loaded AND has visible detections.
     *
     * @returns The visible SVG detection groups, otherwise null.
     */
    CollectionModelDrawableMask.prototype.getVisibleSvgDetectionGroups = function (enabledDetectionGroups, log) {
        var _a;
        if (!this.parsedSvg) {
            log === null || log === void 0 ? void 0 : log.warn({ drawable: this.id }, 'getVisibleSvgDetectionGroups: SVG has not been loaded');
            return null;
        }
        if (!this.parsedSvg.svg) {
            log === null || log === void 0 ? void 0 : log.warn({ drawable: this.id }, 'getVisibleSvgDetectionGroups: Root of SVG is missing <svg> tag');
            return null;
        }
        if (!((_a = this.parsedSvg.svg.g) === null || _a === void 0 ? void 0 : _a.length)) {
            log === null || log === void 0 ? void 0 : log.warn({ drawable: this.id }, 'getVisibleSvgDetectionGroups: SVG contains no detection groups');
            return null;
        }
        // Check if any of the SVG detection groups are present in enabledDetectionGroups.
        if (!this.parsedSvg.svg.g.some(function (g) { return enabledDetectionGroups.includes(g.id); })) {
            log === null || log === void 0 ? void 0 : log.warn({
                drawable: this.id,
                enabledDetectionGroups: enabledDetectionGroups,
                maskDetectionGroups: this.parsedSvg.svg.g.map(function (g) { return g.id; })
            }, 'getVisibleSvgDetectionGroups: None of the detection groups in the SVG were listed in enabledDetectionGroups');
            return null;
        }
        // Mask contains at least one visible detection group, which means the user can see it.
        return this.parsedSvg.svg.g;
    };
    CollectionModelDrawableMask.isMask = function (t) {
        return t instanceof CollectionModelDrawableMask;
    };
    CollectionModelDrawableMask.prototype.clone = function (newParentDrawableState) {
        return new CollectionModelDrawableMask(newParentDrawableState, this.id, this.pukekoLocation);
    };
    CollectionModelDrawableMask.prototype.equals = function (other) {
        return (other instanceof CollectionModelDrawableMask
            && this.pukekoLocation.product_version_number === other.pukekoLocation.product_version_number
            && this.pukekoLocation.resource_path === other.pukekoLocation.resource_path
            && this._equals(other));
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionModelDrawableMask.prototype, "parsedSvg", void 0);
    return CollectionModelDrawableMask;
}(drawable_1.CollectionModelDrawable));
exports.CollectionModelDrawableMask = CollectionModelDrawableMask;
//# sourceMappingURL=mask.drawable.js.map